module.exports = __webpack_public_path__ + "static/media/warehouse-alt.d79472a2.svg";